import { useMutation } from '@tanstack/react-query';
import { POST, POST_UPDATE_TRACKING } from '../../../../services';
import { openAlert } from '../../../../components/alert/hooks';

export const useUpdateTracking = ({ onSuccessCallBack }) => {
  const { mutate, isPending } = useMutation({
    mutationFn: async (payload) => {
      const response = await POST(POST_UPDATE_TRACKING(), payload);
      onSuccessCallBack && onSuccessCallBack(response);
      return response.result;
    },
    onSuccess: () => {
      openAlert({
        model: 'message',
        type: 'success',
        message: 'แก้ไขเลขพัสดุสำเร็จ',
      });
    },
  });
  return { mutate, loading: isPending };
};
